import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Kiosk from './Kiosk';
import { signInStudent } from 'utils/kiosk';
import useStarfishAPI from 'hooks/useStarfishAPI';
import SFLoader from 'common/SFLoader';
import { VirtualSignInOptions } from 'utils/types';
import KioskError from "./KioskError";

/**
 * @param {Object} props - see propTypes
 * @returns {Object} For when a student virtually checks-in to a kiosk. Since we know who the user is here, we can auto sign
 * them into the kiosk and take them to the correct step in the flow.
 */
function VirtualCheckInContainer(props) {
    const [initialStep, setInitialStep] = useState(null);
    const [signInStudentResponse, signInStudentAPI] = useStarfishAPI();
    const [error, setError] = useState(null);
    
    useEffect(() => {
        // auto sign in student
        signInStudent(signInStudentAPI, { kioskId: props.kioskId, serviceId: props.virtualSignInOptions.virtualServiceId })
    }, [props.virtualSignInOptions.virtualServiceId]);

    /**
     * set the initial step of the flow depending on if the student is checking in as a walk in, checking in for an 
     * appointment/group session or checking their status after already having signed in.
     */
    useEffect(() => {
        if (signInStudentResponse.success) {
            setError(null);
            setInitialStep(props.processSignIn(signInStudentResponse.data));
        }
        if (!signInStudentResponse.success) setError(signInStudentResponse.error);
    }, [signInStudentResponse]);

    if (error !== null) return <KioskError error={error} studentId={props.virtualSignInOptions.virtualStudentId} />;
    if (initialStep === null) return <SFLoader>Loading {props.kioskName}...</SFLoader>;
    return <Kiosk {...props} initialStep={initialStep} />;
}

VirtualCheckInContainer.propTypes = {
    kioskId: PropTypes.number.isRequired,
    kioskName: PropTypes.string.isRequired,
    processSignIn: PropTypes.func.isRequired,
    virtualSignInOptions: VirtualSignInOptions.isRequired
};

export default VirtualCheckInContainer;
